// window._ = require('lodash');

window.Vue = require('vue');

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */


try {
    $ = jQuery = require('jquery');

} catch (e) {
    console.error('Unable to load jquery module' + e);

}


try {
    require('jquery.cookie');
} catch (e) {
    console.error('Unable to load jquery cookie module' + e);

}

/**
 * Image loaded
 *
 * Image loaded used by masonry
 *
 */
try {
    require('./vendor/download');
} catch (e) {
    console.error('Unable to load download module' + e);
}


//Load url search params for IE
(function (w) {

    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window);
require('es6-promise').polyfill();
require('isomorphic-fetch');

/**
 * Image loaded
 *
 * Image loaded used by masonry
 *
 */
// try {
//     require('./vendor/imagesloaded.pkgd.min');
// } catch (e) {
//     console.error('Unable to load image loaded module' + e);
// }


/**
 * Masonry
 *
 * grid alignment
 *
 */
if (window.location.href.indexOf("/editor") <= 0) {
    try {
        Masonry = window.masonry = window.Masonry = require('masonry-layout');
    } catch (e) {
        console.error('Unable to load masonry module' + e);
    }

    try {

        // init Masonry
        // const $msnry = new Masonry( '.gridBlockList', {
        //     itemSelector: '.gridListItem',
        //     // use element for option
        //     columnWidth: '.gridListItemSizer',
        //     percentPosition: true,
        //     transitionDuration: '0'
        // });


        // new Masonry('.gridBlockList', {
        //     itemSelector: '.gridListItem',
        //     // use element for option
        //     columnWidth: '.gridListItemSizer',
        //     percentPosition: true,
        //     transitionDuration: '0'
        // });
        if ($('.designsGrid').length > 0) {
            function loadHeightsForTheGrid() {
                let designElements = document.getElementsByClassName("designsGridItem"),
                    $width = designElements[0].getElementsByClassName('.designsGridItemContentInner').offsetWidth;
                for (let i = designElements.length; i--;) {
                    //do stuff
                    let $this = designElements[i],
                        $height = ($width * $this.getAttribute('data-height')) / $this.getAttribute('data-width'),
                        elementImage = $this.getElementsByClassName('designGridItemImg')[0];
                    if (elementImage !== undefined) {
                        let elemA = elementImage.getElementsByTagName('a');
                        if (elemA !== undefined) {
                            elemA[0].style.height = $height + 'px';
                        }
                    }


                }
            }

            window.onload = function () {
                loadHeightsForTheGrid();
                new Masonry('.designsGrid', {
                    itemSelector: '.designsGridItem',
                    // use element for option
                    // columnWidth: '.gridListItemSizer',
                    percentPosition: true,
                    transitionDuration: '0'
                }, 'layout');
                // Access elements in here
                // let $width = $(".designsGridItemContentInner",".designsGridItem").first().width();
                // let designElements = $(".designsGridItem");
                // for(let i=0; i<designElements.length; i++){
                //     let $this = designElements.eq(i),
                //         $height = ($width * $this.data('height')) / $this.data('width');
                //     $('.designGridItemImg a',$this).css({"height": $height})
                //     $this.show();
                // }
                // $(".designsGridItem").each(function () {
                //     let $this = $(this),
                //         $height = ($width * $this.data('height')) / $this.data('width');
                //     $('.designGridItemImg a',$this).css({"height": $height})
                // });

            };
            // layout Masonry after each image loads
            // $('.designsGrid').imagesLoaded().progress(function () {

            // });

            $(window).resize(function () {
                loadHeightsForTheGrid();
                new Masonry('.designsGrid', {
                    itemSelector: '.designsGridItem',
                    // use element for option
                    // columnWidth: '.gridListItemSizer',
                    percentPosition: true,
                    transitionDuration: '0'
                }, 'reload');
            });
        }


    } catch (e) {
        console.error('Failed to init masonry' + e);
    }
}


/**
 * Salvattore
 *
 * grid alignment
 *
 */
try {
    require('./vendor/salvattore.js');
} catch (e) {
    console.error('Unable to load salvatore module' + e);
}


/**
 * We'll load perfect scrollbar
 */
try {
    Ps = PerfectScrollbar = require('./vendor/perfect-scrollbar.js');
} catch (e) {
    console.error('Unable to load perfect scrollbar module' + e);
} finally {
    window.perfectScrollDark = $('.scroll-dark');
    window.perfectScrollWhite = $('.scroll-white');
    perfectScrollDark.perfectScrollbar();
    perfectScrollWhite.perfectScrollbar();


}


/**
 * Window resize trigger events
 */
window.addEventListener('resize', function () {
    // Update the perfect scrollbar
    perfectScrollDark.perfectScrollbar('update');
    perfectScrollWhite.perfectScrollbar('update');
});


/**
 * Auto textarea grow
 */
$(document)
    .one('focus.autoExpand', 'textarea.autoExpand', function () {
        var savedValue = this.value;
        this.value = '';
        this.baseScrollHeight = this.scrollHeight;
        this.value = savedValue;
    })
    .on('input.autoExpand', 'textarea.autoExpand', function () {
        var minRows = this.getAttribute('data-min-rows') | 0, rows;
        this.rows = minRows;
        rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 17);
        this.rows = minRows + rows;
    });

/**
 * Removes autocomplete from the inputs
 */
if (document.getElementsByTagName) {

    var inputElements = document.getElementsByTagName('input');

    for (i = 0; inputElements[i]; i++) {

        if (inputElements[i].className && (inputElements[i].className.indexOf('disableAutoComplete') != -1)) {

            inputElements[i].setAttribute('autocomplete', 'off');

        }

    }

}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });


if (window.location.hash == '#_=_' || window.location.hash == '#') {
    history.replaceState
        ? history.replaceState(null, null, window.location.href.split('#')[0])
        : window.location.hash = '';
}
// history.pushState('', document.title, window.location.pathname);
